import { render } from "./WorkTemplateModal.vue?vue&type=template&id=2a138102&scoped=true"
import script from "./WorkTemplateModal.vue?vue&type=script&lang=js"
export * from "./WorkTemplateModal.vue?vue&type=script&lang=js"

import "./WorkTemplateModal.vue?vue&type=style&index=0&id=2a138102&scoped=true&lang=scss"

import exportComponent from "/var/www/html/vg.carvex.ee/frontend/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a138102"]])

export default __exports__